export default "__VITE_ASSET__BvmZ5cK2__"